module.exports = __webpack_public_path__ + "img/download.9f13e8f9.png";